import React, { useState, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import Tvideo from '../assets/ThankYou.mp4';
import { useCookies } from 'react-cookie';

const ThankYou = () => {
    const [cookies, removeCookie] = useCookies(["authToken", 'username']);
    const navigate = useNavigate();

  const [showThankYou, setShowThankYou] = useState(false);

  const handleVideoEnd = () => {

    setShowThankYou(true);

  };


  const handleLogout = () => {
    removeCookie("authToken", { path: "/" });
    removeCookie('username', { path: '/' });
    navigate("/SignInCandidate");
  };

  useEffect(() => {

    const videoElement = document.getElementById('thankYouVideo');

    videoElement.addEventListener('ended', handleVideoEnd);

    return () => {

      videoElement.removeEventListener('ended', handleVideoEnd);

    };

  }, []);

  return (
<div className="relative flex items-center justify-center min-h-screen bg-slate-500 p-4 overflow-hidden">
<video

        id="thankYouVideo"

        src={Tvideo}

        muted

        autoPlay

        className="absolute inset-0 w-full h-full object-cover z-0"
></video>

      {showThankYou && (
<div className="relative bg-slate-100 p-8 rounded-lg shadow-lg text-center w-full max-w-4xl z-10">
<h1 className="text-2xl font-bold mb-6">Thanks for Submitting details!</h1>
<h1 className="text-4xl font-bold mb-6">A Warm Welcome to GlobalXperts</h1>

          {/* <p className="text-lg mb-6">Thanks for Submitting details! One of our experts will contact you shortly</p> */}
<div className="mt-8 flex justify-center gap-4">
{/* <Link to="/my-orders" className="bg-black hover:bg-gray-800 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">

              Download Your Response
</Link> */}
<button onClick={handleLogout} className="flex items-center py-2.5 px-4  border bg-gray-400 font-bold rounded-full text-xs hover:bg-gray-700">
         
          <span className={` `}>LogOut</span>
        </button>
</div>
</div>

      )}
</div>

  );

};

export default ThankYou;
 